import { isUndefinedNullOrEmpty } from '../utils';
import { operationStatuses, operationIsComplete } from '../statuses';

const Operation = function(operationId, operationType, operationStatus, startedAt, startedBy, lastError) {
    const self = this;

    if(isUndefinedNullOrEmpty(operationId)) { throw 'operationId is required'; }
    if(isUndefinedNullOrEmpty(operationType)) { throw 'operationType is required'; }
    if(isUndefinedNullOrEmpty(operationStatus)) { throw 'operationStatus is required'; }

    self.operationId = operationId;
    self.type = operationType;
    self.operationStatus = operationStatus;
    self.startedAt = startedAt;
    self.startedBy = startedBy;
    self.lastError = lastError;
};

Operation.prototype.isInProgress = function() {
    return !operationIsComplete(this.operationStatus);
};

Operation.prototype.isFaulted = function() {
    return this.operationStatus === operationStatuses.faulted;
};

Operation.prototype.isSuccessful = function() {
    return this.operationStatus === operationStatuses.successful;
};

export default Operation;


// WEBPACK FOOTER //
// ./src/js/models/Operation.js